export default {
  name: 'Header',
  data() {
    return {
      userName: this.$store.state.user.name
    };
  },
  methods: {},
  created() {}
};